// extracted by mini-css-extract-plugin
export default {"favorites":"location_favorite-locations_favorites","focusTrash":"location_favorite-locations_focusTrash"};